import { trim, each } from '../util/lang'

let regs = {
  'android': /android/i,
  'iphone': /iphone/i,
  'ipad': /ipad/i,
  'ipod': /ipod/i,
  'weixin': /micromessenger/i,
  'mqq': /QQ\//i,
  'alipay': /alipayclient/i,
  'miniprogram': /miniprogram/i,
  'ding': /dingtalk/i,
  'passenger': /didi.passenger/i,
  'soda': /soda.embedcustomer/i,
  'didies': /didies/i, // 企业级
  'lite': /didi.lite/i,
  'sdk': /didi.sdk/i,
  'driverAndroid': /didigsui/i, // app内用
  'driverIOS': /ddudriver/i, // app内用
  'chrome': /chrome\//i,
  'fusion': /fusionkit/i,
  // 'fusion': /didi.passenger\/.*fusionkit/i, //fusion&passenger
  'guarana': /guarana/i,
  'driverTW': /didi.driver.tw/i,
  'driverHK': /didi.driver.hk/i,
  'global': /global/i,
  'mini': /didi.mini/i,
  'hm': /hm.passenger/i, // 街兔app(电单车)
  'rainbow': /didi\.rainbow/i,
  'mpbank': /MPBank\//i,
  'blord': /didi.blord/i
}

function parseUserAgent () {
  let ret = {},
      ua = window.navigator.userAgent

  for (let key in regs) {
    ret[key] = regs[key].test(ua)
  }

  ret.blord && (ret.passenger = false)
  ret.ios = ret.iphone || ret.ipad || ret.ipod
  ret.mobile = ret.ios || ret.android
  ret.driver = ret.driverAndroid || ret.driverIOS
  ret.pc = !ret.mobile

  ret.uber = ret.lite

  ret.dingding = ret.ding

  if (ret.ding) {
    ret.alipay = false
  }

  if (window.chrome && window.chrome) {
    ret.chrome = true
  }

  ret.inNative = ret.driver || ret.passenger || ret.lite || ret.didies || ret.rainbow || ret.fusion
  return ret
}

function parseVersion (version) {
  version = version || ''
  version = version.split('.')
  version.length = 4

  let ret = []

  each(version, function (n) {
    n = n * 1
    if (n) {
      ret.push(n >= 10 ? n : '0' + n)
    } else {
      ret.push('00')
    }
  })

  return parseInt(ret.join(''), 10)
};

/**
 * 比较版本
 * compare('1.0.1','<','1.0.2') 是微信
 *
 */
function compare (v1, reg, v2) {
  v1 = parseVersion(v1)
  v2 = parseVersion(v2)
  reg = trim(reg) || ''
  if (reg.indexOf('=') !== -1 && v1 === v2) {
    return true
  }
  if (reg.indexOf('>') !== -1 && v1 > v2) {
    return true
  }
  if (reg.indexOf('<') !== -1 && v1 < v2) {
    return true
  }
  return false
};

/**
 * 环境判断
 * isEnv('weixin') 是微信
 * isEnv('ios')    是ios
 * isEnv('ipad, iphone') 是iPad 或者 iphone
 * isEnv('ios.weixin') 是否是ios版微信
 *
 */
function isEnv (strs) {
  let str = strs.split(',')
  let ua = parseUserAgent()

  let check = function (rote) {
    rote = trim(rote) || ''
    if (!rote) {
      return false
    }
    let rotes = rote.split('.')
    let ret = true

    each(rotes, function (r, i) {
      if (!ua[r]) {
        ret = false
        return false
      }
    })

    return ret
  }

  let ret = false

  each(str, function (s, i) {
    if (check(s)) {
      ret = true
      return false
    }
  })

  return ret
}

export default {
  ua: parseUserAgent(),
  is: isEnv,
  compare
}
